import { Component, OnInit, inject } from "@angular/core";
import { selectorUser, IUser } from "@app/core/auth/identity/user.reducer";
import { select, Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { takeUntil, filter } from "rxjs/operators";
import { selectorLanguage } from "@app/core/i18n/i18n.reducer";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { Router, NavigationEnd, RouterLink } from "@angular/router";
import { Location } from "@angular/common";

@Component({
  selector: "ddd-common-footer",
  templateUrl: "./common-footer.component.html",
  styleUrls: ["./common-footer.component.scss"],
  standalone: true,
  imports: [RouterLink, TranslateModule]
})
export class CommonFooterComponent implements OnInit {
  private readonly store = inject<Store<any>>(Store);
  private readonly translateService = inject(TranslateService);
  private location = inject(Location);
  private router = inject(Router);

  private unsubscribe$: Subject<void> = new Subject<void>();
  private PRIVACY_POLICY_URL =
    "https://carne-digital.atlassian.net/wiki/external/2723151873/MGE3MDJhNTc4NDc5NDZjM2E4OTI3MTQwNWFmNDZkMTA";
  private TERMS_AND_CONDITIONS_URL =
    "https://carne-digital.atlassian.net/wiki/external/2723151873/MGE3MDJhNTc4NDc5NDZjM2E4OTI3MTQwNWFmNDZkMTA";
  user: IUser;

  public footerCopyrightDate = new Date().getFullYear();
  public showFooter: boolean;
  public isKYDBrand: boolean;
  public buildVersion: string;

  ngOnInit() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.initCommonFooter();
    });

    this.initCommonFooter();

    this.store.pipe(select(selectorUser), takeUntil(this.unsubscribe$)).subscribe((user) => {
      if (user) {
        this.user = user;
        if (user.staticData) {
          this.buildVersion = `v. ${user.staticData.buildVersion}`;
        }
        this.isKYDBrand = this.user.brand === "KYD";
      }
    });

    this.store.pipe(select(selectorLanguage), takeUntil(this.unsubscribe$)).subscribe((lang) => {
      this.translateService.setDefaultLang(lang.currentLanguage);
    });
  }

  public initCommonFooter() {
    if (this.location.path().includes("callback")) {
      this.showFooter = false;
    } else if (this.location.path().includes("setup")) {
      this.showFooter = false;
    } else {
      this.showFooter = true;
    }
  }
}
